/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebphotospartial3Inputs */

const en_placewebphotospartial3 = /** @type {(inputs: Placewebphotospartial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Some photos could not be uploaded`)
};

const de_placewebphotospartial3 = /** @type {(inputs: Placewebphotospartial3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einige Fotos konnten nicht hochgeladen werden`)
};

/**
* | output |
* | --- |
* | "Some photos could not be uploaded" |
*
* @param {Placewebphotospartial3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebphotospartial3 = /** @type {((inputs?: Placewebphotospartial3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebphotospartial3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebphotospartial3(inputs)
	return de_placewebphotospartial3(inputs)
});
export { placewebphotospartial3 as "placeWebPhotosPartial" }